module.exports = __webpack_public_path__ + "img/visuel22-hk.a25d3909.jpg";